export default __webpack_public_path__ + "static/media/Bracers of the Refectory.cf6f8b11.jpg";